import { createSelector } from '@reduxjs/toolkit'
import { getForms } from 'model/selectors/base'
import _ from 'lodash'

export const getSortedForms = createSelector([getForms], forms => {
  const liveForms = _.filter(forms, f => f.deleted === 0)
  return _.orderBy(liveForms, 'createdAt', 'desc')
})
